/*
* Copyright (C) Regione Lombardia
*/
import { Pipe, PipeTransform } from '@angular/core';
import { AnagraficaFascePercentuali } from '@models';

@Pipe({
    name: 'anagraficaFascePercentuali',
})
export class AnagraficaFascePercentualiPipe implements PipeTransform {

    transform(value: number, items: AnagraficaFascePercentuali[]) {
        return items.find(i => i.id === value)?.descrizione || '';
    }

}
